import React, { LegacyRef, useRef, useState } from "react";

import "./video_card.scss";
import { observer } from "mobx-react-lite";

import crossIcon from "../../../../assets/images/icons/cross.svg";
import plusIcon from "../../../../assets/images/icons/plus.svg";
import { GalleryVideoType } from "../../../../schemas/gallery_video";
import Player from "../../../../components/player/player";

import {
	ClearPlayers,
	KillAllPlayers,
} from "../../../../components/player/controls";
import { setPriority } from "os";

function GalleryVideoCard(props: { video: GalleryVideoType }) {
	const [cardOpen, changeCardOpen] = useState<boolean>(false);

	const [modalOpen, changeModalOpen] = useState<boolean>(false);
	const [modalShow, changeModalShow] = useState<boolean>(false);

	const toggleImagesSlider = () => {
		if (!modalShow) {
			changeModalOpen(!modalOpen);
			setTimeout(() => {
				changeModalShow(!modalShow);
			}, 250);
		} else {
			changeModalShow(!modalShow);
			setTimeout(() => changeModalOpen(!modalOpen), 500);
		}
	};

	const [value, setValue] = useState(0);
	function useForceUpdate() {
		return () => setValue((value) => value + 1);
	}
	const forceUpdate = useForceUpdate();

	return (
		<div
			className={"card " + (cardOpen ? "open" : "")}
			onClick={(e) => {
				e.stopPropagation();
				changeCardOpen(!cardOpen);
				setTimeout(() => {
					forceUpdate();
					setTimeout(() => {
						if (!cardOpen) {
							ClearPlayers();
						} else {
							KillAllPlayers();
						}
					}, 100);
				}, 100);
			}}
		>
			<div className="icon_position">
				<div className="icon_wrapper">
					<div className="icon">
						<img
							src={plusIcon}
							className={"plus " + (cardOpen ? "hide" : "")}
							alt=""
						></img>
						<img
							src={crossIcon}
							className={"cross " + (cardOpen ? "" : "hide")}
							alt=""
						></img>
					</div>
				</div>
			</div>
			<div className="cover_wrapper">
				{!cardOpen && (
					<img
						className="cover main"
						src={props.video.pic ?? props.video.detail.images[0]}
						alt=""
					></img>
				)}
				{cardOpen && (
					<div
						className="player_wrapper"
						onClick={(e) => e.stopPropagation()}
					>
						{/*
							<ReactPlayer
							onClick={(e: any) => {
								e.stopPropagation();
								toggleImagesSlider();
							}}
							width="100%"
							height="100%"
							playing={cardOpen && !modalOpen}
							loop={true}
							volume={0.01}
							url={props.video.detail.video[0]}
							config={{
								file: {
									attributes: {
										controlsList: "nodownload",
									},
								},
							}}
						/>
							*/}

						<div id={"videoplay" + props.video.id}></div>
						{value !== -1}
						<Player
							id={"videoplay" + props.video.id}
							file={
								"http://37.220.80.202/" +
								props.video.detail.video
							}
						/>
					</div>
				)}
			</div>

			<div className="content">
				<div className="name">{props.video.name}</div>
				<div className="year">{props.video.year}</div>
				{props.video.detail.detail_text && (
					<div
						className="description"
						dangerouslySetInnerHTML={{
							__html: props.video.detail.detail_text,
						}}
					></div>
				)}
			</div>

			{modalOpen && (
				<div
					className="modal_wrapper"
					style={{
						opacity: +modalShow,
						transition: "all .5s",
					}}
					onClick={() => toggleImagesSlider()}
				></div>
			)}
		</div>
	);
}

export default observer(GalleryVideoCard);
